export default __webpack_public_path__ + "static/media/segura.e1417d3e.png";